module.exports = __webpack_public_path__ + "img/grid-2.8131dc44.svg";